/**
 * @module {bool} util/detect/passive-listeners
 * @parent util.modules
 *
 * Tests whether the browser supports passive event listeners.
 */
define('util/detect/passive-listeners',[], function() {

	"use strict";

	var supported = false;

	if ( Object.defineProperty && document.addEventListener ) {
		// Define an options object with a getter to see if its passive property
		// is accessed by addEventListener, signaling support for the property.
		var options = Object.defineProperty({}, "passive", { get: function(){ supported = true }});

		// The following listener registration will access the options object and
		// thus run the intended test synchronously, but because the listener 
		// argument is null it will not actually bind anything.
		window.addEventListener( "test-passive", null, options );
	}

	return supported;
});
